import styled from 'styled-components';
import { MozartModal, MozartButton } from '@pgforsta/mozart_ui/lib/v4';
import ModalWrapper from '../styled/ModalWrapper';

const List = styled.ul`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  list-style-position: inside;
`;

const AddSourcesErrorsModal = ({ errors, onClose }) => {
  const keys = Object.keys(errors);
  const totalKeys = keys.length;

  const renderErrors = () =>
    keys.map((key, index) => <li key={index}>{`${key}: ${errors[key]}`}</li>);

  return (
    <ModalWrapper>
      <MozartModal
        show={totalKeys > 0}
        onClose={onClose}
        title={`The following error${totalKeys > 1 ? 's' : ''} ${
          totalKeys > 1 ? 'have' : 'has'
        } occurred`}
      >
        <List>{renderErrors()}</List>
        <MozartButton onClick={onClose}>Ok</MozartButton>
      </MozartModal>
    </ModalWrapper>
  );
};

export default AddSourcesErrorsModal;
